module.exports = __webpack_public_path__ + "static/media/pigeon-flying.91c43001.png";